import { apolloClient } from "../../vue-apollo";
import {
    GET_CATEROGIA_VIDEO,
    GET_PAGINACION_VIDEO,
    GET_VIDEOS_CON_PAGINACION,
    GET_VIDEO
} from "../../graphql/queries";
import {
    AGREGAR_COMENTARIO_EMPRESA,
    EDITAR_COMENTARIO_EMPRESA,
    ELIMINAR_COMENTARIO_EMPRESA,
    DAR_LIKE_COMENTARIO_EMPRESA,
    QUITAR_LIKE_COMENTARIO_EMPRESA

} from "../../graphql/mutations";

export default {
    namespaced: true,
    state: {
        categoriasVideos: [],
        paginacionTotalVideos: [],
        videosPlataforma: [],
        featuredVideo: []
    },
    getters: {
    },
    mutations: {
        
        SET_CATEGORIA_VIDEO(state, categoria){
            state.categoriasVideos = categoria;
        },
        
        SET_PAGINADOR_VIDEOS(state, paginacion){
            state.paginacionTotalVideos = paginacion;
        },

        SET_VIDEOS_PAGINADOS(state, videos){
            state.videosPlataforma = videos;
        },

        SET_VIDEO(state, unVideo){
            state.featuredVideo = unVideo;
            state.featuredVideo.comentarios.forEach(function(comentario) {
                comentario.isEditing = false;
                comentario.respuesta = [];
                comentario.respuestas_comentarios.forEach(function(respuesta){
                    respuesta.isEditing = false;
                    
                });
                
            });
        },

		SET_LIKE_VIDEO(state, likeResult) {
			state.featuredVideo.likes = state.featuredVideo.likes ?? [];
			state.featuredVideo.likes.unshift({ id_like: likeResult.id_like });
			state.featuredVideo.confirm_like = { id_like: likeResult.id_like };
		},
		REMOVE_LIKE_VIDEO(state, likeResult) {
			state.featuredVideo.likes = state.featuredVideo.likes.filter(like => like.id_like !== likeResult.id_like);
			state.featuredVideo.confirm_like = null;
		},

        SET_LIKE_VIDEO_COMENTARIO(state, likecomentario) {
            let comentario_index = state.featuredVideo.comentarios.findIndex(comentario => comentario.id_comentario == likecomentario.id_comentario);
            if (comentario_index != undefined) {
                state.featuredVideo.comentarios[comentario_index].likes = likecomentario.likes;
            }
        },

        SET_COMENTARIO_VIDEO(state, comentario){
            comentario.isEditing = false;
            comentario.respuesta = [];
            state.featuredVideo.comentarios.unshift(comentario);
        },

        SET_UPDATE_COMENTARIO_VIDEO(state, upComentario){

            let comentario_index = state.featuredVideo.comentarios.findIndex(comentario => comentario.id_comentario == upComentario.id_comentario);
            if (comentario_index != undefined) {
                upComentario.isEditing = false;
                if (state.featuredVideo.comentarios.length > 0) Object.assign(state.featuredVideo.comentarios[comentario_index], upComentario)
            }
        },

        DEL_COMENTARIO_VIDEO(state, comentario){
            let found_index = state.featuredVideo.comentarios.findIndex(coment => coment.id_comentario == comentario.id_comentario);
            if (found_index != undefined) {
                state.featuredVideo.comentarios.splice(found_index, 1);
            }
        },
    },
    actions: {

        async getCategoriaVideo({ commit }, data_) {
            let response = null;
            let params = {
                query: GET_CATEROGIA_VIDEO,
                variables: data_
            }
            try {
            await apolloClient.query(params).then(res => {
                if (!res.loading) response = res.data.categoriasVideos;
            });
            }
            catch(e){
            console.log("Falla error, getCategoriaVideo ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    if (response.length==0){
                        resolve(false);
                    }
                    else {
                        resolve(response);
                        commit("SET_CATEGORIA_VIDEO", response);
                    }
                }
                else {
                    resolve(false);
                }
            });
            
            
        },

        async getPaginacionVideos({ commit }, data_) {
            let response = null;
            let params = {
                query: GET_PAGINACION_VIDEO,
                variables: data_
            }
            try {
                await apolloClient.query(params).then(res => {
                    if (!res.loading) response = res.data.paginacionTotalVideos;
                });
            }
            catch(e){
                console.log("Falla error, getPaginacionVideos ", e);
            }
            return new Promise((resolve)=>{
            if(response!=null){
                if (response.length==0){
                    resolve(false);
                }
                else {
                    resolve(response);
                    commit("SET_PAGINADOR_VIDEOS", response);
                }
            }
            else {
                resolve(false);
            }
            
            });
            
            
        },

        async getVideosPaginados({ commit }, data_) {
            let response = null;
            let params = {
                query: GET_VIDEOS_CON_PAGINACION,
                variables: data_
            }
            try {
            await apolloClient.query(params).then(res => {
                if (!res.loading) response = res.data.videosPlataforma;
            });
            }
            catch(e){
            console.log("Falla error, getVideosPaginados ", e);
            }
            return new Promise((resolve)=>{
            if(response!=null){
                if (response.length==0){
                    resolve(false);
                }
                else {
                    resolve(response);
                    commit("SET_VIDEOS_PAGINADOS", response);
                }
            }
            else {
                resolve(false);
            }
            });
            
            
        },
        // metodo para unificar el paginador con el que enviar el array del objeto de video
        async getVideosCompletos({ dispatch, commit }, payload)
        {
            let response = null;
            const paginatedVideo = await dispatch("getPaginacionVideos", payload.data2_);
            let pagina = payload.pagina;
            let ids_videos = [];
            if (paginatedVideo){
                paginatedVideo.forEach((data)=>{
                    if(data.pagina == pagina){
                        ids_videos = data.videos;
                    }
                }); 
            }
            let data_ = {
                id_empresa: payload.data2_.id_empresa,
                id_usuario: payload.data2_.id_usuario,
                ids: ids_videos
            }
            let params = {
                query: GET_VIDEOS_CON_PAGINACION,
                variables: data_
            }
            try {
            await apolloClient.query(params).then(res => {
                if (!res.loading) response = res.data.videosPlataforma;
            });
            }
            catch(e){
            console.log("Falla error, getVideosCompletos ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    if (response.length==0){
                        commit("SET_VIDEOS_PAGINADOS", response);
                        resolve(false);
                    }
                    else {
                        commit("SET_VIDEOS_PAGINADOS", response);
                        resolve(response);
                    }
                }
                else {
                    resolve(false);
                }
            });
        },
        async getUnVideo({ commit }, data_) {
            let response = null;
            let params = {
                query: GET_VIDEO,
                variables: data_
            }
            try {
            await apolloClient.query(params).then(res => {
                if (!res.loading) response = res.data.video;
            });
            }
            catch(e){
            console.log("Falla error, getUnVideo ", e);
            }
            return new Promise((resolve)=>{
            if(response!=null){
                if (response.length==0){
                    resolve(false);
                }
                else {
                    commit("SET_VIDEO", response);
                    resolve(response);
                }
            }
            else {
                resolve(false);
            }
            
            });
            
            
        },

        async crearComentariosEmpresaVideo({commit}, data_){
            let response = null;
            //let data = [];
            let params = {
                mutation: AGREGAR_COMENTARIO_EMPRESA,
                variables: data_
            }
            try{
                await apolloClient.mutate(params).then(res => {
                    if (!res.loading) response = res.data.agregarComentarioEmpresa;
                });
            }
            catch(e){
                console.log("Falla metodo crearComentariosEmpresaVideo: ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                resolve(response);
                    if(data_.id_comentario==""){
                        commit("SET_COMENTARIO_VIDEO", response);
                    }else{
                        response.id_padre_comentario = data_.id_comentario;
                        commit("SET_COMENTARIO_DEL_COMENTARIO_NOTICIA", response);
                    }
                }
                else {
                resolve(false);
                }
        
            });
        },

        async editarComentarioEmpresaVideo({commit}, data_){
            let response = null;
            //let data = [];
            let params = {
                mutation: EDITAR_COMENTARIO_EMPRESA,
                variables: data_
            }
            try{
                await apolloClient.mutate(params).then(res => {
                    if (!res.loading) response = res.data.editarComentarioEmpresa;
                });
            }
            catch(e){
                console.log("Falla metodo editarComentarioEmpresaVideo: ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                resolve(response);
                commit("SET_UPDATE_COMENTARIO_VIDEO", response);
                }
                else {
                resolve(false);
                }
        
            });
        },

        async eliminarComentarioEmpresaVideo({commit}, data_){
            let response = null;
            let data = [];
            let params = {
                mutation: ELIMINAR_COMENTARIO_EMPRESA,
                variables: data_
            }
            try
            {
                await apolloClient.mutate(params).then(res => {
                    if (!res.loading) data = res.data.eliminarComentarioEmpresa;
                    response = data;
                });
            }
            catch(e){
                console.log("Error de eliminarComentarioEmpresaVideo post: ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    commit("DEL_COMENTARIO_VIDEO", response);
                    resolve(response);
                }
                else {
                    resolve(false);
                }
                
            }); 
        },

        async addLikeVideo({ commit, dispatch }, payload) {
			Object.assign(payload, {
				id_modulo: "6",
				id_subobjeto: "0"
			});
			const response = await dispatch("LikesModule/darLikeAction", payload, { root: true });
			commit("SET_LIKE_VIDEO", Object.assign(response, payload));
			return response;
		},
		async delLikeVideo({ commit, dispatch }, payload) {
			Object.assign(payload, {
				id_modulo: "6",
				id_subobjeto: "0"
			});
			const response = await dispatch("LikesModule/quitarLikeAction", payload, { root: true });
			commit("REMOVE_LIKE_VIDEO", Object.assign(response, payload));
			return response;
		},

        async addLikeComentarioEmpresa({commit}, data_){
            let response = null;
            let data = [];
            let params = {
                mutation: DAR_LIKE_COMENTARIO_EMPRESA,
                variables: data_
            }
            try{
                await apolloClient.mutate(params).then(res => {
                    if (!res.loading) data = res.data.darLikeComentarioEmpresa;
                    response = data;
                });
            }
            catch(e){
                console.log("Falla metodo addLikeComentarioEmpresa: ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                resolve(response);
                commit("SET_LIKE_VIDEO_COMENTARIO", response);
                }
                else {
                resolve(false);
                }
        
            });
        },

        async delLikeComentarioEmpresa({commit}, data_){
            let response = null;
            let data = [];
            let params = {
                mutation: QUITAR_LIKE_COMENTARIO_EMPRESA,
                variables: data_
            }
            try{
                await apolloClient.mutate(params).then(res => {
                    if (!res.loading) data = res.data.quitarLikeComentarioEmpresa;
                    response = data;
                });
            }
            catch(e){
                console.log("Falla metodo delLikeComentarioEmpresa: ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                resolve(response);
                commit("SET_LIKE_VIDEO_COMENTARIO", response);
                }
                else {
                resolve(false);
                }
        
            });
        },
    }
};